export default __webpack_public_path__ + "static/media/default.a3b635da.png";